module.exports = __webpack_public_path__ + "img/405-cbad72.png";